import AdminSidebarShell from "./AdminSidebarShell";

const AdminHome = () => {
  return (
    <AdminSidebarShell activeItem="dashboard">
      <div style={page}>
        <main style={workspace}>
          <div style={placeholderCard}>
            <div style={placeholderWrap}>
              <p style={placeholderText}>Family Circle Personalized Group Visual</p>
              <p style={placeholderSubtext}>Under development</p>
            </div>
          </div>
        </main>
      </div>
    </AdminSidebarShell>
  );
};

export default AdminHome;

const page = {
  minHeight: "calc(100vh - 72px)",
  display: "flex",
  flexDirection: "column",
  background: "#f4f6f8"
};

const workspace = {
  background: "linear-gradient(180deg, #f7fafc 0%, #eef3f8 100%)",
  padding: "24px",
  flex: 1,
  minHeight: 0
};

const placeholderCard = {
  background: "#ffffff",
  borderRadius: "18px",
  border: "1px solid #dbe6ef",
  boxShadow: "0 10px 30px rgba(14,85,128,0.08)",
  minHeight: "calc(100vh - 208px)",
  padding: "24px"
};

const placeholderWrap = {
  height: "100%",
  minHeight: "calc(100vh - 272px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  textAlign: "center"
};

const placeholderText = {
  margin: 0,
  fontSize: "clamp(24px, 2.3vw, 30px)",
  fontWeight: "600",
  color: "#1e5f84",
  textAlign: "center"
};

const placeholderSubtext = {
  margin: "6px 0 0",
  fontSize: "clamp(24px, 2.3vw, 30px)",
  fontWeight: "600",
  color: "#1e5f84",
  textAlign: "center"
};
